// Events Supreme – Stories-style Gallery
(() => {
  const root = document.querySelector('[data-es]');
  if (!root) return;

  const rail = root.querySelector('[data-es-rail]');
  const prev = root.querySelector('[data-es-prev]');
  const next = root.querySelector('[data-es-next]');

  // Scroll navigation
  const scrollByCard = (dir) => {
    const card = rail?.querySelector('[data-es-card]');
    if (!card) return;
    const gap = parseInt(getComputedStyle(rail).gap) || 12;
    rail.scrollBy({ left: (card.offsetWidth + gap) * dir, behavior: 'smooth' });
  };

  prev?.addEventListener('click', () => scrollByCard(-1));
  next?.addEventListener('click', () => scrollByCard(1));

  // Stories Lightbox
  const stories = createStoriesLightbox();

  // Click card to open
  root.addEventListener('click', (e) => {
    const card = e.target.closest('[data-es-card]');
    if (!card) return;

    const coverImg = card.querySelector('.ES__img');
    const links = card.querySelectorAll('.ES__gallery [data-es-full]');
    const urls = Array.from(links).map(a => a.href).filter(Boolean);

    if (!urls.length) return;

    const meta = {
      title: card.querySelector('.ES__name')?.textContent || '',
      date: card.querySelector('.ES__date')?.textContent || '',
      avatar: coverImg?.src || ''
    };

    stories.open(urls, 0, meta);
  });

  function createStoriesLightbox() {
    const el = document.createElement('div');
    el.className = 'ESLB';
    el.innerHTML = `
      <div class="ESLB__progress"></div>
      <div class="ESLB__header">
        <div class="ESLB__info">
          <img class="ESLB__avatar" src="" alt="">
          <div>
            <div class="ESLB__title"></div>
            <div class="ESLB__date"></div>
          </div>
        </div>
        <button class="ESLB__close" aria-label="Close">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <line x1="18" y1="6" x2="6" y2="18"/>
            <line x1="6" y1="6" x2="18" y2="18"/>
          </svg>
        </button>
      </div>
      <div class="ESLB__stage">
        <img class="ESLB__img" alt="">
      </div>
      <div class="ESLB__zone ESLB__zone--prev"></div>
      <div class="ESLB__zone ESLB__zone--next"></div>
    `;
    document.body.appendChild(el);

    const progress = el.querySelector('.ESLB__progress');
    const img = el.querySelector('.ESLB__img');
    const avatar = el.querySelector('.ESLB__avatar');
    const titleEl = el.querySelector('.ESLB__title');
    const dateEl = el.querySelector('.ESLB__date');
    const closeBtn = el.querySelector('.ESLB__close');
    const zonePrev = el.querySelector('.ESLB__zone--prev');
    const zoneNext = el.querySelector('.ESLB__zone--next');

    let urls = [];
    let idx = 0;
    const DURATION = 5; // seconds

    const buildBars = () => {
      progress.innerHTML = urls.map(() => 
        `<div class="ESLB__bar"><div class="ESLB__bar-fill"></div></div>`
      ).join('');
    };

    const updateBars = () => {
      const bars = progress.querySelectorAll('.ESLB__bar');
      bars.forEach((bar, i) => {
        bar.classList.remove('is-done', 'is-active');
        bar.style.setProperty('--duration', DURATION + 's');
        
        if (i < idx) {
          bar.classList.add('is-done');
        } else if (i === idx) {
          // Force reflow to restart animation
          bar.offsetHeight;
          bar.classList.add('is-active');
        }
      });
    };

    const onAnimationEnd = (e) => {
      if (e.target.closest('.ESLB__bar')?.classList.contains('is-active')) {
        goNext();
      }
    };

    progress.addEventListener('animationend', onAnimationEnd);

    const show = () => {
      updateBars();
      img.classList.remove('is-loaded');

      const newImg = new Image();
      newImg.onload = () => {
        img.src = urls[idx];
        img.classList.add('is-loaded');
      };
      newImg.src = urls[idx];
    };

    const goNext = () => {
      if (idx < urls.length - 1) {
        idx++;
        show();
      } else {
        close();
      }
    };

    const goPrev = () => {
      if (idx > 0) {
        idx--;
      }
      show();
    };

    const open = (_urls, startIdx, meta) => {
      urls = _urls;
      idx = startIdx;
      buildBars();

      if (meta) {
        avatar.src = meta.avatar;
        titleEl.textContent = meta.title;
        dateEl.textContent = meta.date;
      }

      el.classList.add('is-open');
      el.classList.remove('is-paused');
      document.body.style.overflow = 'hidden';
      show();
    };

    const close = () => {
      el.classList.remove('is-open', 'is-paused');
      document.body.style.overflow = '';
      img.src = '';
    };

    // Events
    closeBtn.addEventListener('click', close);
    zonePrev.addEventListener('click', goPrev);
    zoneNext.addEventListener('click', goNext);

    // Pause on hold
    const pause = () => el.classList.add('is-paused');
    const resume = () => el.classList.remove('is-paused');

    el.addEventListener('mousedown', pause);
    el.addEventListener('mouseup', resume);
    el.addEventListener('mouseleave', resume);
    el.addEventListener('touchstart', pause, { passive: true });
    el.addEventListener('touchend', resume, { passive: true });

    // Keyboard
    window.addEventListener('keydown', (e) => {
      if (!el.classList.contains('is-open')) return;
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowLeft') goPrev();
      if (e.key === 'ArrowRight') goNext();
    });

    return { open, close };
  }
})();